import React from "react";
import { Flex, Text, Box, Divider, Progress, Badge } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface RiskCardProps {
  value: string | number;
  label: string;
  risk: string;
  color: string;
  progress: number;
  progressColor: string;
  textColor: string;
}

const RiskCard: React.FC<RiskCardProps> = ({
  value,
  label,
  risk,
  color,
  progress,
  progressColor,
  textColor,
}) => {
  return (
    <Box
      flex="1"
      border="1px solid #E0E0E0"
      borderRadius="16px"
      p="12px"
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
    >
      {/* Value */}
      <Text fontSize="32px" fontWeight="bold" color="black">
        {value}
      </Text>

      {/* Risk row */}
      <Flex w="100%" alignItems="center" mt={2} gap={2}>
        <Text fontSize="14px" fontWeight="400" color="#5C6670">
          {label}
        </Text>
        <Badge
          borderRadius="16px"
          padding="2px 12px"
          bg={color}
          color={textColor}
          fontSize="14px"
          fontWeight="400"
        >
          {risk}
        </Badge>
      </Flex>

      {/* Divider */}
      <Divider my={3} />

      {/* Progress bar */}
      <Progress
        value={progress}
        colorScheme={progressColor as any}
        w="100%"
        borderRadius="8px"
      />
    </Box>
  );
};

const HazardsCards: React.FC = () => {
  const { t } = useTranslation("common");

  const cards = [
    {
      value: 75,
      label: t("hazardsCards.riskLevel"),
      risk: t("hazardsCards.critical"),
      color: "#DC35450A",
      textColor: "#DC3545",
      progressColor: "red",
      progress: 90,
    },
    {
      value: 50,
      label: t("hazardsCards.riskLevel"),
      risk: t("hazardsCards.medium"),
      color: "#DE7F040A",
      textColor: "#DE7F04",
      progress: 60,
      progressColor: "orange",
    },
    {
      value: 20,
      label: t("hazardsCards.riskLevel"),
      risk: t("hazardsCards.low"),
      color: "#3AB65A0A",
      textColor: "#3AB65A",
      progress: 30,
      progressColor: "green",
    },
  ];

  return (
    <Flex
      gap={6}
      border="1px solid #E0E0E0"
      borderRadius="16px"
      p={6}
      flexDirection="column"
    >
      <Text fontSize="24px" fontWeight="bold" color="black">
        {t("hazardsCards.title")}
      </Text>
      {cards?.map((c, idx) => (
        <RiskCard key={idx} {...c} />
      ))}
    </Flex>
  );
};

export default HazardsCards;
